import { useContext, useEffect } from 'react';

import { useQuery } from 'react-query';

import { useRouter } from '../';
import { ApiContext, CoreContext } from '../../providers';
import { useUserStore } from '../../store/user-store';

export const useProfileQuery = () => {
    const { pathname } = useRouter();
    const { Upscore } = useContext(ApiContext);
    const { store } = useContext(CoreContext);
    const userStore = useUserStore();

    const profileQuery = useQuery(['profile'], Upscore.getUserProfile);

    useEffect(() => {
        if (profileQuery.data && !userStore.profile) {
            userStore.setProfile(profileQuery.data);
        }
    }, [profileQuery]);

    return profileQuery;
};
